const config = {
    defaultPath: '/',
    borderRadius: 8,
    fontFamily: "'Montserrat', sans-serif"
};

export default config;
